// the pool op glb.soup (poolwork.js imports it through pool-forest.js): ONE GLBQ
// building tile (buildings/<tx>_<ty>.glb) -> its world-space soup in 128 m
// cell order, off the main thread. readGlbSoup (game/glbsoup.js, the one
// reader) on three's MeshoptDecoder imported here — its own wasm, no
// useWorkers (the decoder's own worker is built from its function source by
// name, which the minified bundle renames: buildings.js _load) — then
// buildings.js cellOrder's sort (cellruns.js cellSort on the soup's
// positions, every attribute permuted per triangle). Pure: no three core, no DOM.
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { readGlbSoup } from '../../game/glbsoup.js';
import { cellSort, permuteTris } from './cellruns.js';
import { swapSoup } from './bldswap.js';

// the soup's arrays and their item sizes (glbsoup.js soupOf)
export const SOUP_ARRAYS = [['position', 3], ['normal', 3], ['color', 3], ['uv0', 2], ['uv1', 2]];

// args { buf, swap? } (the GLB bytes, transferred) -> readGlbSoup's { ntri,
// position, normal, color, uv0|null, uv1|null, q, t } with every array in
// cell order, + order (Uint32Array new triangle -> old; null: one cell, the
// soup as read) and cells ({ cells, blocks } | null)
export async function glbSoup(args) {
  const s = await readGlbSoup(new Uint8Array(args.buf), MeshoptDecoder);
  const cs = cellSort(s.position, null);
  if (cs) for (const [k, n] of SOUP_ARRAYS) if (s[k]) permuteTris(cs.order, s[k], n);
  // FAR-SWAP (bldswap.js): the soup's aSwap + its trims (uv0, in place) + the
  // far tile's clusters, measured here in cell order (args.swap: { t, white })
  const swap = args.swap ? swapSoup(s, args.swap.t, args.swap.white) : null;
  const result = { ...s, swap, order: cs ? cs.order : null, cells: cs ? { cells: cs.cells, blocks: cs.blocks } : null };
  const transfer = SOUP_ARRAYS.filter(([k]) => s[k]).map(([k]) => s[k].buffer);
  if (cs) transfer.push(cs.order.buffer);
  if (swap && swap.aSwap) transfer.push(swap.aSwap.buffer);
  return { result, transfer };
}
